/* eslint-disable no-unused-vars */
import React, { FC } from "react";

// import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
/** Apollo */
// import AuthApolloProvider from "../auth/authApolloProvider";
/**
 * Router
 */
// import { BrowserRouter } from "react-router-dom";
import { DrawerProvider } from "./DrawerContext";
// import { LocalizationProvider } from "@mui/x-date-pickers/
// LocalizationProvider";
/**
 * Custom providers
 */
import { BrazeProvider } from "./BrazeContext";
import { ModalProvider } from "./ModalContext";
import { PageTitleContextProvider } from "./PageTitleContext";
import { PanelRightProvider } from "./PanelRightContext";

/**
 * Redux
 */
// import { Provider } from "react-redux";
/**
 * MUI Theme
 */
// import { ThemeProvider } from "@mui/material";
// import { defaultTheme } from "../styles/muiTheme";
// import store from "../state/store";

export const ContextManager: FC = ({ children }) => (

  <PageTitleContextProvider>
    <ModalProvider>
      {/* TO be removed post cleanup: Drawer and Panel right providers */}
      <DrawerProvider>
        <PanelRightProvider>
          <BrazeProvider>
            {children}
          </BrazeProvider>
        </PanelRightProvider>
      </DrawerProvider>
    </ModalProvider>
  </PageTitleContextProvider>

);
